import {
  INIT_CATEGORY,
  CLICK_CATEGORY,
} from "@/shared/components/photo_gallery/constants/action_types";

// 初期値
const initialState = {
  categories: [],
  categoryId: null,
};

// Action の種別によってステータスを更新
// eslint-disable-next-line default-param-last
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case INIT_CATEGORY: {
      return {
        categories: payload.categories,
        categoryId: payload.categoryId,
      };
    }
    case CLICK_CATEGORY: {
      let categoryId = null;
      if (payload.categoryId) {
        categoryId = payload.categoryId;
      }
      // eslint-disable-next-line no-param-reassign
      state.categoryId = categoryId;
      return state;
    }
    default: {
      return state;
    }
  }
};
